export default "/_next/static/images/statistic-background-516655e8db91775dd9b93699d9bffc5d.svg";